import { render, staticRenderFns } from "./ShortVideoFriend.vue?vue&type=template&id=1c7089f4&scoped=true"
import script from "./ShortVideoFriend.vue?vue&type=script&lang=js"
export * from "./ShortVideoFriend.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoFriend.vue?vue&type=style&index=0&id=1c7089f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7089f4",
  null
  
)

export default component.exports